import React from 'react';
import ReactDOM from 'react-dom/client';
import { configure } from 'mobx';
import dayjs from 'dayjs';

import duration from 'dayjs/plugin/duration';
import 'dayjs/locale/zh-tw';

import 'normalize.css';
import './index.css';
import './customAntd.css';

import 'src/i18n';
import App from './App';

import reportWebVitals from './reportWebVitals';

dayjs.extend(duration);
dayjs.locale('zh-tw');

configure({
  enforceActions: 'always'
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
